import {useState} from "react";
import List from "@mui/material/List";
import {FormGroup, ListItem, Stack, TextField} from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import FormControlLabel from "@mui/material/FormControlLabel";


/**
 * List of buses and search
 * @param units
 * @param checked
 * @param setChecked
 * @param saved
 * @returns {JSX.Element}
 * @constructor
 */
const BusSearch = ({units, checked, setChecked, saved}) => {

    const [virtualUnits, setVirtualUnits] = useState(units);

    /**
     * Toggle Action
     * @param value
     * @returns {(function(): void)|*}
     */
    const handleToggle = (value) => () => {
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        setChecked(newChecked);
    };

    /**
     * Handle All toggle
     * @param event
     */
    const handleToggleAll = (event) => {
        const isChecked = event.target.checked;
        if (isChecked) {
            setChecked(units.map(u => u.number));
        }
        else {
            setChecked([]);
        }
    };

    /**
     * Virtual Search in the list of units
     * @param dirtyValue
     */
    const searchInList = (dirtyValue) => {
        const value = dirtyValue.target.value;

        if (value === "") {
            setVirtualUnits(units);
            return;
        }
        const vUnits = units.filter(unit => ("" + unit.number).includes(value));
        setVirtualUnits(vUnits);
    }

    const inSaved = (numberOfUnit) => {
        const filtered = saved.filter(([meters, id, {data}], i) => {
            return parseInt(data['unit_number']) === parseInt(numberOfUnit)
        });
        return filtered.length > 0;
    }

    return (
        <Stack>
            <TextField
                hiddenLabel
                id="search-box"
                variant={"standard"}
                onChange={searchInList}
                placeholder={"Búsqueda de económico"}
                sx={{px: 2, position: "sticky"}}
            />
            <List dense sx={{bgcolor: 'background.paper', height: "400px", overflow: "scroll"}}>
                {virtualUnits.map(({id, number}) => {
                    const labelId = `checkbox-list-secondary-label-${number}`;
                    return (
                        <ListItem
                            key={id}
                            secondaryAction={
                                <Checkbox
                                    edge="end"
                                    onChange={handleToggle(number)}
                                    checked={checked.indexOf(number) !== -1}
                                    inputProps={{'aria-labelledby': labelId}}
                                />
                            }
                            disablePadding
                        >
                            <ListItemButton sx={{
                                border: "1px solid " + (inSaved(number) ? "white" : "teal")
                            }}>
                                <ListItemText id={labelId} primary={
                                    <>
                                        <Typography sx={{display: 'inline', fontWeight: "medium"}}
                                                    component="span"
                                                    variant="body1"
                                                    color="text.primary">
                                            Eco {number}
                                        </Typography>
                                    </>
                                } secondary={
                                    <>
                                        <Typography sx={{display: 'inline'}}
                                                    component="span"
                                                    variant="body2"
                                                    color={inSaved(number) ? "text.primary" : "teal"}>
                                            {inSaved(number) ? "Pensión" : "En ruta"}
                                        </Typography>
                                    </>
                                }
                                />
                            </ListItemButton>
                        </ListItem>
                    );
                })}
            </List>
            <FormGroup sx={{ px: 2 }}>
                <FormControlLabel control={<Checkbox defaultChecked onChange={handleToggleAll}/>} label="Todas las unidades" />
            </FormGroup>
        </Stack>
    );
}

export default BusSearch